export default __webpack_public_path__ + "static/media/voltage.98095263.svg";